import { trigger, state, style, transition, animate } from '@angular/animations';

export const SlideInOutAnimation = [
  trigger('slideInOut', [
    state(
      'in',
      style({
        margin: 0,
        // css styles when the element is in slide_in
      }),
    ),
    state(
      'out',
      style({
        margin: '-100px 0 0 0',
        height: '0px',
        // css styles when the element is in slide_out
      }),
    ),
    // animation effect when transitioning from one state to another
    transition('in <=> out', animate(300)),
  ]),
];
